export default __webpack_public_path__ + "static/media/login-image.21e8ba3f.jpg";